export function initStoreCheckout() {
  document.querySelectorAll("[data-checkout-quantity]").forEach((form) => {
    const input = form.querySelector("input[name='quantity']")
    if (!input) return

    let timeout
    const submit = () => {
      window.clearTimeout(timeout)
      if (input.reportValidity()) form.requestSubmit()
    }

    input.addEventListener("input", () => {
      window.clearTimeout(timeout)
      timeout = window.setTimeout(submit, 350)
    })
    input.addEventListener("change", submit)
  })
}
